import { render, staticRenderFns } from "./gxzForm.vue?vue&type=template&id=de66b6ba&"
import script from "./gxzForm.vue?vue&type=script&lang=js&"
export * from "./gxzForm.vue?vue&type=script&lang=js&"
import style0 from "./gxzForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports